// SCSS variable values for use in JS/TS (react-select styles, charts, ...).
// Replaces the ICSS `:export` block of misc.module.scss, which Turbopack does not support.
// Values are the compiled results of variables/misc.scss (and colours.scss) - keep them in sync when those change.
const misc: Record<string, string> = {
  'btn-border-radius': '0',
  'btn-border-radius-lg': '0',
  'btn-border-radius-sm': '0',
  'loading-icon-size': '26px',
  'badge-border-radius': '0',
  'input-padding-y': '0.5em',
  'input-padding-x': '0.625em',
  'input-border-radius': '0',
  'input-border-radius-lg': '0',
  'input-border-radius-sm': '0',
  'select-input-border-width': '1px',
  'form-group-margin-bottom': '1.3em',
  'border-radius': '0',
  'custom-control-indicator-size': '1.2rem',
  'card-spacer-y': '0.4em',
  'card-spacer-x': '1.25em',
}

export default misc
